import { render, staticRenderFns } from "./AuctionComponent.vue?vue&type=template&id=ba086ddc&scoped=true&"
import script from "./AuctionComponent.vue?vue&type=script&lang=ts&"
export * from "./AuctionComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AuctionComponent.vue?vue&type=style&index=0&id=ba086ddc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba086ddc",
  null
  
)

export default component.exports